/**
 * WebSocket / REST session matching for /battle/:gameId.
 * Used by BattleUI so Escape → navigate away → new PvE does not apply abandoned-game
 * payloads (winner, etc.). Resign keeps a coherent server flow with explicit gameId.
 *
 * BattleUI resolves the active session from react-router `location.pathname` (not
 * `window.location.pathname`) so HashRouter + Electron (file://) match the real route.
 */

export function extractBattleGameIdFromPath(pathname) {
  if (!pathname || typeof pathname !== 'string') {
    return null;
  }
  const m = pathname.match(/\/battle\/([^/]+)/);
  return m ? m[1] : null;
}

export function resolveExpectedSessionGameId(getPathname, gameIdRefValue, gameIdProp) {
  const path = typeof getPathname === 'function' ? getPathname() : '';
  const fromUrl = extractBattleGameIdFromPath(path);
  if (fromUrl != null && String(fromUrl).trim() !== '') {
    return String(fromUrl);
  }
  if (gameIdRefValue != null && String(gameIdRefValue).trim() !== '') {
    return String(gameIdRefValue);
  }
  if (gameIdProp != null && String(gameIdProp).trim() !== '') {
    return String(gameIdProp);
  }
  return null;
}

/**
 * @returns {boolean} true if the message must not be applied to the current battle session
 */
export function isWsMessageForDifferentSession(msgGameId, expectedSessionId) {
  if (msgGameId == null || String(msgGameId).trim() === '') {
    return true;
  }
  if (expectedSessionId == null) {
    return false;
  }
  return String(msgGameId) !== String(expectedSessionId);
}

/**
 * Ignore REST GET /game/:id body when the user already navigated to another battle.
 */
export function shouldDiscardStaleGameFetch(currentGameId, requestedGameId) {
  return String(currentGameId) !== String(requestedGameId);
}
